import React, {useRef, useState} from "react"
import emailjs from '@emailjs/browser';
import "./contact.css"
import {AiOutlineMail, AiOutlineTwitter, AiFillLinkedin} from "react-icons/ai"

const Contact = () => {
  const [loading, setLoading] = useState(false);

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    setLoading(true);

    
    emailjs.sendForm('service_pbjojxd', 'template_9jb4gp7', form.current, 'qzINDtGygqQTsXNxp')
    .then((result) => {
      console.log(result.text);
      
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }, (error) => {
      console.log(error.text);
      setLoading(false);
      alert("Something went wrong, please try again later");
    });
    
    e.target.reset();
  };
    

  return (
    <section id="contact">
      <h5>Get in Touch</h5>
      <h2>Contact Me</h2>

      <div className="container contact__container">
        <div className="contact__options">
          <article className="contact__option">
            <AiOutlineMail className="contact__option-icon" />
            <h4>Email</h4>
            <h5>goeldev01@gmail.com</h5>
            <a href="mailto:goeldev01@gmail.com" target="_blank" rel="noreferrer">Send a mail.</a>
          </article>
          <article className="contact__option">
            <AiOutlineTwitter className="contact__option-icon" />
            <h4>Twitter</h4>
            <h5>@goeldev01</h5>
            <a href="https://twitter.com/goeldev01" target="_blank" rel="noreferrer">Drop a follow.</a>
          </article>
          <article className="contact__option">
            <AiFillLinkedin className="contact__option-icon" />
            <h4>LinkedIn</h4>
            <h5>Dev Goel</h5>
            <a href="https://www.linkedin.com/in/dev-goel-833a25197/" target="_blank" rel="noreferrer">Connect with me!</a>
          </article>          
        </div>
        
        <form ref={form} onSubmit={sendEmail}>
          <input type="text" name="name" placeholder="Your Full Name" required />
          <input type="email" name="email" placeholder="Your Email" required />
          <textarea name="message" rows="7" placeholder="Your Message" required />          
          <button type="submit" className="btn btn-primary spinner_btn">
            {loading && (
              <div className="loading_spinner"></div>
            )}
            {!loading && <p>Send Message</p>}
          </button>
        </form>
      </div>
    </section>
  )
}

export default Contact;